import React, { SyntheticEvent } from 'react';
import { Row, Cell, ColumnInterface } from 'react-table';

import { Checkbox } from '@trqk/components';

import { summarizeRowsAbove } from '../../constants';

interface IncludeAudioFileColumn extends ColumnInterface<TrqkGapChannelAudio> {
    send: SendGapAnalysisEvent;
}

interface IncludeWorkCellProps {
    cell: Cell<TrqkGapChannelAudio, GapWorkIncludeWorkCellValue>;
    column: IncludeAudioFileColumn;
    row: Row<TrqkGapChannelAudio>;
}

/**
 * For summary rows, this component returns null.
 * For non-summary rows, this component renders a checkbox that allows the user to select an audio
 * file in order to include it in the Gap Analysis report.
 * @param props - {@link IncludeWorkCellProps}
 * @returns JSX
 */
export const IncludeWorkCell = ({
    cell,
    column,
    row,
}: IncludeWorkCellProps): JSX.Element | null => {
    if (row.subRows.length > summarizeRowsAbove) {
        return null;
    }

    const { checked, onChange } = row.getToggleRowSelectedProps();
    const channelId = cell?.value?.channelId ?? null;
    const gapAudioId = cell?.value?.gapAudioId ?? null;

    const { send } = column;

    return (
        <div className="pt-1 pl-1">
            <Checkbox
                checked={checked ?? false}
                color="primary"
                inputId={`row-selection-${row.id}`}
                onChange={(e: SyntheticEvent) => {
                    const target = e.target as HTMLInputElement;

                    if (channelId !== null) {
                        if (onChange) {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore -- this type def is wrong; we do need to pass the event
                            onChange(e);

                            // Edit the `include` state for this audio file
                            send({
                                type: 'EDIT_AUDIO_INCLUDE',
                                value: {
                                    gapAudioId,
                                    channelId,
                                    include: target.checked,
                                },
                            });
                        }
                    }
                }}
                size="large"
            />
        </div>
    );
};
